import { Text, TextAs, Button, TextSizes } from '@clockout-dev/design-elements';
import SectionCard from '../../common/sectionCard/SectionCard';
import SupportStatusPill from '../../support/elements/SupportStatusPill';
import ReviewDetailRow from './ReviewDetailRow';
import pageStyles from '../../common/page/styles/page.module.scss';
import styles from '../styles/review-support-ticket-card.module.scss';

function ReviewSupportTicketCard({ review, onCreateTicket, onGoToTicket }) {
    const hasTicket = review?.associated_ticket;

    return (
        <SectionCard title="Support Case">
            {!hasTicket ? (
                <div>
                    <Text as={TextAs.SPAN} size={TextSizes.SMALL}>
                        No support case has been opened for this review yet.
                    </Text>
                    <div className={styles.buttonContainer}>
                        <Button
                            type="button"
                            variant="link"
                            color="secondary"
                            size="m"
                            className={pageStyles.backLink}
                            onClick={onCreateTicket}
                        >
                            Create Support Case
                        </Button>
                    </div>
                </div>
            ) : (
                <div>
                    <ReviewDetailRow label="Subject" value={review.associated_ticket.subject} />
                    <ReviewDetailRow
                        label="Status"
                        value={<SupportStatusPill status={review.associated_ticket.status} />}
                    />
                    <div className={styles.buttonContainer}>
                        <Button
                            type="button"
                            variant="link"
                            color="secondary"
                            size="m"
                            className={pageStyles.backLink}
                            onClick={onGoToTicket}
                        >
                            Go to Support Case
                        </Button>
                    </div>
                </div>
            )}
        </SectionCard>
    );
}

export default ReviewSupportTicketCard;
